"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDocumentRequestDetailDto = instanceOfDocumentRequestDetailDto;
exports.DocumentRequestDetailDtoFromJSON = DocumentRequestDetailDtoFromJSON;
exports.DocumentRequestDetailDtoFromJSONTyped = DocumentRequestDetailDtoFromJSONTyped;
exports.DocumentRequestDetailDtoToJSON = DocumentRequestDetailDtoToJSON;
exports.DocumentRequestDetailDtoToJSONTyped = DocumentRequestDetailDtoToJSONTyped;
var EnquiryDetailsMediaDto_1 = require("./EnquiryDetailsMediaDto");
/**
 * Check if a given object implements the DocumentRequestDetailDto interface.
 */
function instanceOfDocumentRequestDetailDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('isBAndPInspectionRequired' in value) || value['isBAndPInspectionRequired'] === undefined)
        return false;
    if (!('media' in value) || value['media'] === undefined)
        return false;
    if (!('documentsMailed' in value) || value['documentsMailed'] === undefined)
        return false;
    return true;
}
function DocumentRequestDetailDtoFromJSON(json) {
    return DocumentRequestDetailDtoFromJSONTyped(json, false);
}
function DocumentRequestDetailDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'email': json['email'],
        'isBAndPInspectionRequired': json['isBAndPInspectionRequired'],
        'media': (json['media'].map(EnquiryDetailsMediaDto_1.EnquiryDetailsMediaDtoFromJSON)),
        'documentsMailed': json['documentsMailed'],
    };
}
function DocumentRequestDetailDtoToJSON(json) {
    return DocumentRequestDetailDtoToJSONTyped(json, false);
}
function DocumentRequestDetailDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'email': value['email'],
        'isBAndPInspectionRequired': value['isBAndPInspectionRequired'],
        'media': (value['media'].map(EnquiryDetailsMediaDto_1.EnquiryDetailsMediaDtoToJSON)),
        'documentsMailed': value['documentsMailed'],
    };
}
